import { folioManagementDefault } from "../../../../../../components/evidences/utils"
import { EvidenceData } from "../../../../../../hooks/evidences/typyng"
import { EvidenceTypeBody } from "../../../../../../service/questionarie/bodys"
import { EvidencesTypeEnum } from "../../../../../../utils/enums/evidences"
import { transformEvidences } from "../../../../../../utils/methods/evidences"
import { removeAllReference } from "../../../../../../utils/methods/removedReference"
import { Item } from "../../../../../../utils/types/generals"
import { fields } from "../../../../constants"
import { removeKeys, typeUser } from "./contants"
import { GetActionPlanPayload, GetActionPlanReturn, GetEvidencesPayload } from "./type"

const getEvidenceData = ({ evidenceType }: GetEvidencesPayload): EvidenceTypeBody[] => {
    const filterData: EvidenceTypeBody[] = evidenceType
        ?.filter((item) => !!item?.active)
        ?.map((item) => {
            const sizes = (item?.maxSize as Item)?.value ?? item?.maxCharacters
            const amounts = item?.maxAmount
            const userType = item.type
            const minAmount = item?.minAmount ?? 1
            const required = item?.required
            const copyItem = removeAllReference(item)

            delete copyItem?.maxSize
            delete copyItem?.maxAmount
            delete copyItem?.minAmount
            delete copyItem?.active
            delete copyItem?.required
            delete copyItem?.maxCharacters
            delete copyItem?.key
            delete copyItem?.label
            delete copyItem?.value
            delete copyItem?.type
            const arrayTypes = Object.entries(copyItem ?? {})?.filter(([_, item]) => item)

            return removeKeys({
                object: {
                    ...!!sizes && { sizes: sizes },
                    ...!!arrayTypes?.length && { types: arrayTypes.map(([key]) => key) },
                    amounts: (amounts ?? 1) as number,
                    min: Number(minAmount ?? 1),
                    description: '',
                    required: !!required,
                    evidenceTypeId: transformEvidences[(item?.key as string) ?? ''],
                    ...userType && { type: userType }
                },
                name: (item?.key ?? '') as string
            })
        }) ?? []

    return filterData
}
function flattenObject(obj, parentKey = '', result = {}) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            const newKey = parentKey ? `${parentKey}_${key}` : key;
            if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key]) && key !== 'maxSize') {
                flattenObject(obj[key], newKey, result);
            } else {
                result[newKey] = obj[key];
            }
        }
    }
    return result;
}

const convertEvideceArray = (evidence?: EvidenceData[], addType?: boolean /* 'CREATOR' | 'SOLVER' */) => {
    const types = [typeUser.CREATOR, typeUser.SOLVER]

    return evidence?.filter(item => !!item)?.flatMap((item, index) => {
        return Object.keys(item).map(key => {
            const value = item?.[key]
            const flattened = flattenObject(value);
            if (value?.maxSize) {
                flattened.maxSize = value.maxSize;
            }
            if (value?.maxCharacters) {
                flattened.maxCharacters = value.maxCharacters;
            }
            return { ...flattened, key: key, ...addType && { type: value?.type ?? types[index] }, ...value?.type && { type: value?.type ?? null } };
        });
    });
}
const getActionPlans = ({ data, t }: GetActionPlanPayload): GetActionPlanReturn => {
    const title = data?.description?.title?.toString()
    const description = data?.description?.description?.toString()
    const maxRejections = data?.data?.maxReject?.toString()
    const sendEmail = !!data?.data?.sendEmail ? 1 : 0
    const actionPlanItems = fields?.filter(item => !!data?.data?.[`${item}-check`]).map(item => ({
        question: t(`general.questions.${item}`),
        required: !!data?.data?.[`${item}-switch`] ? 1 : 0
    }))
    const evidencesAction = convertEvideceArray(data?.evidence, true)
    const actionPlanEvidences = getEvidenceData({ evidenceType: evidencesAction })
    let count = 0
    if (!data?.description?.title) { count = count + 1 }
    if (maxRejections == "") { count = count + 1 }
    if (!actionPlanItems?.length && !actionPlanEvidences?.length) { count = count + 1 }
    let evidenceFolio = convertEvideceArray(data?.evidenceFolio)

    return {
        data: [{
            templateName: (title ?? ''),
            description: (description ?? ''),
            maxRejections: (maxRejections ?? ''),
            sendEmail: sendEmail,
            userConfigEvidence: data?.options?.evidences?.sameConfig ? typeUser.CREATOR_SOLVER : null,
            statusId: 1,
            ...!!actionPlanItems?.length && { actionPlanItems: actionPlanItems },
            required: 1,
            subtractPoints: 1,
            ...!!actionPlanEvidences?.length && { actionPlanEvidences: actionPlanEvidences },
            configReportFolio: !!data?.activeFolios ? {
                isAreaRequired: true,
                isDepartmentRequired: true,
                askForArea: true,
                askForDepartment: true,
                // isRequired: !!data?.dataFolios?.reportFolioIsRequired,
                configActionPlanReportFolioEvidenceTypes: getEvidenceData({ evidenceType: evidenceFolio, }),
                enableRatingQuestion: !!data?.dataFolios?.enable,
                isRatingQuestionRequired: !!data?.dataFolios?.required,
                ...!!data?.dataFolios?.enable && { ratingQuestion: (data?.dataFolios?.description as string) },
                ...!!data?.dataFolios?.maxRejectsAmount && { maxRejects: (data?.dataFolios?.maxRejectsAmount as string) },
                ...!!data?.dataFolios?.maxFoliosAmount && { max: (data?.dataFolios?.maxFoliosAmount as string) }
            } : null,
        }],
        errors: {
            title: !!data?.description?.title,
            maxRejections: !!maxRejections,
            optionals: !!actionPlanItems?.length || !!actionPlanEvidences?.length,
            count
        }
    }
}
export { getActionPlans, getEvidenceData, convertEvideceArray }